require('./userGroupEditor.i18n.json');
require('./userGroupEditor.tpl.html');
require('./userGroupEditorRepository.js');
require('./userGroupEditorModel.js');
require('./header/userGroupEditorHeaderComponent.js');

/*@ngInject*/
const UserGroupEditorController = function ($rootScope, $scope, $state, $stateParams, $timeout, $uibModal, localization,
                                             configurationMediator, productTypes, coreConstant, configurationConstant,
                                             userGroupEditorModel, dataSetUtil, currentUserModel, authorizationConstants,
                                             coreMediator, userMediator) {

    let translations;

    $scope.viewModel = {
        selectedUsers: '',
        itemName: 'userGroup',
        userGroup:{},
        userRoles: [],
        requestParams: {
            key: 'name',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc'
        },
        selectedUsersRole: [],
        displayList: false,
        isLoading: true,
        isGridEmpty: true,
        hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_USER_GROUPS),
        id: '',
        active: 1,
        inactive: 0,
        userList: []
    };

    localization.getTranslationByKey('userGroupInformation').then(function (result) {
        translations = result;
        $scope.viewModel.userGroup.namePrompt = _.get(translations, 'userGroupNamePrompt');
        $scope.viewModel.userGroup.autoAssign = _.get(translations, 'autoAssignName');
        $scope.viewModel.userGroup.manageUsersName = _.get(translations, 'manageUsersName');
        $scope.viewModel.searchForStep2 = _.get(translations, 'selectUsers');
    }.bind(this));

    function init() {
        userGroupEditorModel.buildUserGroup(parseInt($stateParams.userGroupId));
    }

    $scope.getStatus = function (item) {
        return _.get(translations, 'status.' + item.status);
    };

    $scope.onSortChange = function (event, params) {
        onSort(params.key, params.sortType);
    };

    function loadModel() {
        userGroupEditorModel.hasUnsavedChanges = false;
        $scope.viewModel.userGroup = userGroupEditorModel.getUserGroup($stateParams.userGroupId);
        $scope.viewModel.isLoading = false;
        _.each($scope.viewModel.userGroup.userIds, function (id) {
            if ($scope.viewModel.selectedUsers !== '') {
                $scope.viewModel.selectedUsers += '::';
            }
            $scope.viewModel.selectedUsers += id;
        });
        loadManageUserList();
    }

    function loadManageUserList() {
        userMediator.loadCarrierUserRoles().then((roles) => {

            $scope.viewModel.userRoles = roles;
            let userGroupList = [];
            _.each(roles, function (user) {
                if (_.indexOf($scope.viewModel.userGroup.userIds, user.id) !== -1) {
                    userGroupList.push(user);
                }

                $scope.viewModel.userList.push({
                    name: user.firstName + ' ' + user.lastName + ' (' + user.roles + ')',
                    value: String(user.id)
                });
            });

            $scope.viewModel.displayList = true;
            $scope.viewModel.selectedUsersRole = _.orderBy(userGroupList, ['firstName', 'lastName'], ['asc', 'asc']);
        });
    }

    function isFieldValid() {
        let result = false;
        if (!_.isEmpty($scope.viewModel.userGroup.name) && !_.isEmpty($scope.viewModel.selectedUsersRole)) {
            result = true;
        }
        return result;
    }

    function onSort(key, sortType) {
        $scope.viewModel.selectedUsersRole = _.orderBy($scope.viewModel.selectedUsersRole, [key, 'firstName', 'lastName'], [sortType, sortType, sortType]);
        $timeout(function () {
            $scope.$apply();
        }, 10);
    }

    function updateUserGroupModel() {
        let userGroup = {};
        if (!_.isNil(userGroupEditorModel.getUserGroup())) {
            userGroup.id = userGroupEditorModel.getUserGroup().id;
        }
        userGroup.name = $scope.viewModel.userGroup.name;
        userGroup.status.active = $scope.viewModel.userGroup.status === 'active';
        userGroupEditorModel.setUserGroup(userGroup);
    }

    $scope.$on(coreConstant.event.USER_GROUP_EDITOR_MODEL_UPDATED, function (event, userGroupId) {
        if (parseInt($stateParams.userGroupId) === userGroupId) {
            loadModel();
        }
    });

    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, _.debounce(function (event, itemName) {
        if (itemName === $scope.viewModel.itemName) {
            let tempItemList = _.filter($scope.viewModel.userList, function (item) {
                return item.selected;
            });

            $scope.viewModel.selectedUsersRole = [];
            _.each($scope.viewModel.userRoles, function (user) {
                _.each(tempItemList, function (selectUser) {
                    if (user.id === parseInt(selectUser.value)) {
                        $scope.viewModel.selectedUsersRole.push(user);

                    }
                    $scope.viewModel.displayList = true;
                });
            });
            $scope.onChange();
        }
    }), 500);

    $scope.onChange = function () {
        userGroupEditorModel.hasUnsavedChanges = true;
        userGroupEditorModel.isValid = isFieldValid();
        $scope.viewModel.userGroup.userRoleInfos = $scope.viewModel.selectedUsersRole;
        userGroupEditorModel.setUserGroup($scope.viewModel.userGroup);
        $rootScope.$broadcast(coreConstant.event.USER_GROUP_UPDATED, $scope.viewModel.userGroup.id);
    };

    init();
};

angular.module('umCore')
    .controller('userGroupEditorController', UserGroupEditorController);
